// extracted by mini-css-extract-plugin
export default {"progress":"OrderProgress_progress__CJcBq","active":"OrderProgress_active__Q69ZW"};